import { defineMessages } from 'react-intl'

const scope = `procurify.components.VendorSettings`

export default defineMessages({
  preferredVendorLabel: {
    id: `${scope}.preferredVendorLabel`,
    defaultMessage: 'Preferred vendor',
  },
  poEmailAutomationLabel: {
    id: `${scope}.poEmailAutomationLabel`,
    defaultMessage: 'PO email automation',
  },
  editSettingsLabel: {
    id: `${scope}.editSettingsLabel`,
    defaultMessage: 'Edit settings',
  },
  paymentTermsLabel: {
    id: `${scope}.paymentTermsLabel`,
    defaultMessage: 'Payment terms',
  },
  shippingMethodsLabel: {
    id: `${scope}.shippingMethodsLabel`,
    defaultMessage: 'Shipping methods',
  },
  shippingTermsLabel: {
    id: `${scope}.shippingTermsLabel`,
    defaultMessage: 'Shipping terms',
  },
  pdfLabelSetLabel: {
    id: `${scope}.pdfLabelSetLabel`,
    defaultMessage: 'PDF label set',
  },
  emailRecipientsLabel: {
    id: `${scope}.emailRecipientsLabel`,
    defaultMessage: 'Email recipients',
  },
  yesText: {
    id: `${scope}.yesText`,
    defaultMessage: 'Yes',
  },
  noText: {
    id: `${scope}.noText`,
    defaultMessage: 'No',
  },
  pdfLabelSetTooltipAriaLabel: {
    id: `${scope}.pdfLabelSetTooltipAriaLabel`,
    defaultMessage: 'PO PDF label tooltip',
  },
  pdfLabelSetTooltipMessage: {
    id: `${scope}.pdfLabelSetTooltipMessage`,
    defaultMessage:
      "Procurify's PDF label set is applied by default. Custom PO PDF labels can be created within Procurify Settings.",
  },
  poEmailAutomationTooltipAriaLabel: {
    id: `${scope}.poEmailAutomationTooltipAriaLabel`,
    defaultMessage: 'PO email automation tooltip',
  },
  poEmailAutomationTooltipMessage: {
    id: `${scope}.poEmailAutomationTooltipMessage`,
    defaultMessage:
      'If enabled, the selected email recipients will receive an email when a PO for this vendor is created.',
  },
})
